/** Shown when a delete is attempted (e.g. by keyboard shortcut) that the user isn't allowed to make. */
export const DELETE_FORBIDDEN_MESSAGE = 'Nincs jogosultságod a törléshez.';

interface WithCapabilities {
    capabilities?: { canDelete?: boolean };
}

/**
 * Whether the signed-in user may permanently delete the file, per Drive's `capabilities.canDelete`.
 * An unknown capability counts as allowed: Drive still rejects a forbidden delete with a 403.
 */
export function canDeleteFile(file: WithCapabilities): boolean {
    return file.capabilities?.canDelete !== false;
}

export function canDeleteAll(files: WithCapabilities[]): boolean {
    return files.every(canDeleteFile);
}
